import {AnimationDirectionEnum} from './animation-direction.enum';
import {AnimationFillModeEnum} from './animation-fill.enum';
import {AnimationIterationCountEnum} from './animation-iteration-count.enum';
import {AnimationPlayStateEnum} from './animation-play-state.enum';
import {AnimationTimingFunctionsEnum} from './animation-timing-functions.enum';
import {AnimationGlobalEnum} from './animation-global.enum';

//#region INTERFACE IAnimation

/**
 * Defines the structure for a CSS-based animation configuration.
 *
 * @extends Object
 *
 * @property {string} animation - The name of the animation (should match a defined @keyframes block).
 * @property {string} delay - The delay before the animation starts (e.g., '0s', '200ms').
 * @property {AnimationDirectionEnum | AnimationGlobalEnum} direction - The direction in which the animation is played.
 * @property {string} duration - The total time the animation takes to complete one cycle (e.g., '2s', '500ms').
 * @property {AnimationFillModeEnum | AnimationGlobalEnum} fill - Defines how the animation applies styles to its target before and after execution.
 * @property {AnimationIterationCountEnum | AnimationGlobalEnum | number} iterationCount - Number of times the animation should repeat.
 * @property {AnimationPlayStateEnum | AnimationGlobalEnum} playState - Whether the animation is running or paused.
 * @property {AnimationTimingFunctionsEnum | AnimationGlobalEnum} timingFunction - The speed curve of the animation.
 */
export interface IAnimation extends Object {
  animation: string;
  delay: string;
  direction: AnimationDirectionEnum | AnimationGlobalEnum;
  duration: string;
  fill: AnimationFillModeEnum | AnimationGlobalEnum;
  iterationCount: AnimationIterationCountEnum | AnimationGlobalEnum | number;
  playState: AnimationPlayStateEnum | AnimationGlobalEnum;
  timingFunction: AnimationTimingFunctionsEnum | AnimationGlobalEnum;
}

//#endregion
